module.exports = __webpack_public_path__ + "img/celtic-logo-icon.8bba4dee.png";